export type IconProps = React.JSX.IntrinsicElements['svg'] & {
  name: string;
};

export const Icon = ({ name, ...props }: IconProps) => {
  return (
    <svg style={{fill: 'currentcolor'}} role="img" aria-label={name} {...props}>
      <use href={`/icons/sprite.svg#${name}`} />
    </svg>
  );
};
